  export const getConditionDisplayName = (conditionName: string) => {
    switch (conditionName) {
      case "hypertension":
        return "Hypertension";
      case "diabetes":
        return "Diabetes";
      case "heart_disease":
        return "Heart Disease";
      case "asthma":
        return "Asthma";
      case "arthritis":
        return "Arthritis";
      default:
        return conditionName;
    }
  };

  export const getVitalDisplayName = (vitalName: string) => {
    switch (vitalName) {
      case "blood_pressure":
        return "Blood Pressure";
      case "heart_rate":
        return "Heart Rate";
      case "temperature":
        return "Temperature";
      case "respiratory_rate":
        return "Respiratory Rate";
      case "oxygen_saturation":
        return "Oxygen Saturation";
      default:
        return vitalName;
    }
  };

  export const getFrequencyDisplayName = (frequency: string) => {
    switch (frequency) {
      case "once_daily":
        return "Once daily";
      case "twice_daily":
        return "Twice daily";
      case "three_times_daily":
        return "Three times daily";
      case "four_times_daily":
        return "Four times daily";
      case "as_needed":
        return "As needed";
      default:
        return frequency;
    }
  };
